<template>
  <div>
    <b-overlay variant="light" opacity=".3" blur="2px" :show="show_overlay">
      <b-form-group>
        <b-row class="row-endereco-tipo">
          <b-col>
            <b-form-radio
              v-model="value.internacional"
              name="tipo-endereco"
              class="social-button brasil-icon mr-4"
              :value="false"
              button
              :size="size"
            />

            <b-form-radio
              v-model="value.internacional"
              name="tipo-endereco"
              class="social-button onu-icon ml-4"
              :value="true"
              button
              :size="size"
            />
          </b-col>
        </b-row>
      </b-form-group>

      <div v-if="!value.internacional">
        <b-row>
          <b-col cols="6" md="3">
            <b-form-group label="CEP:">
              <b-form-input
                v-model="cep"
                placeholder="CEP"
                :state="validateState('cep')"
                @keypress="onlyNumbers($event)"
                maxlength="10"
                :size="size"
              ></b-form-input>
              <b-form-invalid-feedback
                :state="isInvalidCep ? !isInvalidCep : validateState('cep')"
              >
                <span v-if="isInvalidCep" v-text="cepMessage" />
                <span v-else-if="!$v.value.cep.required">
                  O CEP é um campo obrigatório.
                </span>
                <span v-else-if="!$v.value.cep.minLength">
                  campo CEP requer um mínimo de 8 caracteres.
                </span>
                <span v-else-if="!$v.value.cep.maxLength">
                  O campo CEP requer um máximo de 8 caracteres.
                </span>
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>

          <b-col cols="6" md="3">
            <b-form-group label="Estado:">
              <select-estado v-model="uf" ref="selecEstado" :size="size" />
            </b-form-group>
          </b-col>

          <b-col cols="12" md>
            <b-form-group label="Cidade:">
              <select-municipio
                v-model="value.cidade_id"
                :uf="uf"
                :state="validateState('cidade_id')"
                ref="selecCidade"
                :size="size"
              />
              <b-form-invalid-feedback :state="validateState('cidade_id')">
                Cidade é um campo obrigatório.
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="6" md="3">
            <b-form-group label="Número:">
              <b-form-input
                v-model="value.numero"
                placeholder="Número"
                :state="validateState('numero')"
                :size="size"
              ></b-form-input>
              <b-form-invalid-feedback>obrigatório.</b-form-invalid-feedback>
            </b-form-group>
          </b-col>

          <b-col cols="12" md>
            <b-form-group label="Logradouro:">
              <b-form-input
                v-model="value.logradouro"
                placeholder="Logradouro"
                :state="validateState('logradouro')"
                :size="size"
              ></b-form-input>
              <b-form-invalid-feedback
                >logradouro é um campo obrigatório.</b-form-invalid-feedback
              >
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="6" md="3" class="d-none d-md-block" />
          <b-col cols="12" md>
            <b-form-group label="Bairro:">
              <b-form-input
                v-model="value.bairro"
                placeholder="Bairro"
                :state="validateState('bairro')"
                :size="size"
              ></b-form-input>
              <b-form-invalid-feedback
                >Bairro é um campo obrigatório.</b-form-invalid-feedback
              >
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="6" md="3" class="d-none d-md-block" />
          <b-col cols="12" md>
            <b-form-group label="Complemento:">
              <b-form-input
                v-model="value.complemento"
                placeholder="Complemento"
                :size="size"
              ></b-form-input>
              <b-form-invalid-feedback>
                Complemento é um campo obrigatório.
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
      </div>
      <div v-else>
        <b-form-group label="País:">
          <select-pais v-model="value.pais_id" ref="selecPais" :size="size" />
          <b-form-invalid-feedback>
            Complemento é um campo obrigatório.
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label="Endereço Internacional:">
          <b-form-textarea
            v-model="value.internacional_descricao"
            placeholder="informe os dados do endereço internacional"
            :size="size"
          ></b-form-textarea>
        </b-form-group>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { mapActions } from "vuex";
import { endereco_empty } from "./Endereco/get_endereco_empty";
import { merge } from "lodash";
import { createCepFetcher } from "@/helpers/functions/findCep";

export default {
  mixins: [validationMixin],
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    size: {
      type: String,
      default: "md",
    },
    cep_required: {
      type: Boolean,
      default: true,
    },
    logradouro_required: {
      type: Boolean,
      default: true,
    },
    numero_required: {
      type: Boolean,
      default: true,
    },
    bairro_required: {
      type: Boolean,
      default: true,
    },
    cidade_id_required: {
      type: Boolean,
      default: true,
    },
    cepDebounce: {
      type: Number,
      default: 500,
    },
  },
  data: () => ({
    uf: "",
    cidade: null,
    show_overlay: false,
    isInvalidCep: false,
    cepMessage: "",
    cepFetcher: null,
  }),
  validations: {
    value: {
      cep: {},
      logradouro: {},
      numero: {},
      bairro: {},
      cidade_id: {},
    },
  },

  computed: {
    cep: {
      set(value) {
        value = value.replace(/\D/g, "").substring(0, 8);
        this.value.cep = value;
      },
      get() {
        let value = "";
        if (this.value && this.value.cep) {
          value = this.value.cep.replace(/^(\d{2})(\d{3})(\d{3})/, "$1.$2-$3");
        }
        return value;
      },
    },
  },
  methods: {
    ...mapActions("municipios", ["ActionFindById"]),
    validateState(name) {
      const { $dirty, $error } = this.$v.value[name];
      return $dirty ? !$error : null;
    },
    isValid() {
      this.$v.value.$touch();
      return !this.$v.value.$anyError;
    },
    onlyNumbers(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  },
  watch: {
    "value.cidade_id": {
      deep: true,
      handler: function (value) {
        if (this.$refs["selecCidade"]) {
          let cidade = this.$refs["selecCidade"].municipio;
          if (cidade) {
            this.$refs["selecEstado"].setBySigla(cidade.estado_sigla);
          }
        }
      },
    },
    cep: function (value) {
      this.isInvalidCep = false;
      this.cepFetcher?.(value);
    },
  },
  created() {
    let endereco = merge(endereco_empty(), this.value ? this.value : {});
    this.$emit("input", endereco);

    if (endereco.cidade) {
      this.uf = endereco.cidade.estado_sigla;
    }

    this.cepFetcher = createCepFetcher({
      debounceMs: this.cepDebounce,
      onLoadingChange: (status) => {
        this.show_overlay = status;
      },
      onSuccess: (response) => {
        this.isInvalidCep = !response;
        this.cepMessage = "Não foram encontrados dados para o CEP informado";

        if (!response) return;

        this.value.logradouro = response.logradouro || this.value.logradouro;
        this.value.bairro = response.bairro || this.value.bairro;
        this.value.cidade_id = response.ibge || this.value.cidade_id;

        if (response.uf) {
          this.uf = response.uf;
        }
      },
      onError: (error) => {
        this.isInvalidCep = true;
        this.cepMessage =
          "Não foi possível buscar os dados a partir do CEP informado. Preencha manualmente.";
        console.log(error);
      },
    });
  },
  beforeDestroy() {
    this.cepFetcher?.cancel?.();
  },
};
</script>
